import React, { Component } from 'react'
import { Tabs } from 'antd';
// import img1 from '../../static/images/news-banner.png'
import case1 from '../../static/images/case-1.png'
import product3 from '../../static/images/product-3.png'


import './index.less';
// const { TabPane } = Tabs;
class NewsCenter extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
        ],
    }
    componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'news-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
            <div style={{ width: '100%' }}>
                <iframe
                    title="news-static"
                    src={`${process.env.PUBLIC_URL}/static/news/news.html`}
                    style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="case-container">
            //     <div className="top-home-carousel">
            //         <Carousel autoplay>
            //             <div><img className="carousel-img" src={img1} alt="" /></div>
            //             {/* <div><img className="carousel-img" src={img1} alt="" /></div>
            //             <div><img className="carousel-img" src={img1} alt="" /></div>
            //             <div><img className="carousel-img" src={img1} alt="" /></div> */}
            //         </Carousel>
            //     </div>
            //     <div className="common-block-home">
            //         <Tabs className="common-block-new-tabs" tabPosition="top">
            //             <TabPane tab="行业资讯" key="1">
            //                 <div className="common-block-case">
            //                     {
            //                         partnerList && partnerList.map((item, index) => (
            //                             <div className="news-detail-block" key={index}>
            //                                 <img className="case-detail-img" src={item.img} alt="" />
            //                                 <div className="news-detail-tips">
            //                                     <a className="news-title" href="https://mp.weixin.qq.com/s/RrO6fYoPupu1R81YVDWy6Q">悦喵Ai首次亮相第十四届中国商业信息化行业大会 &gt;</a>
            //                                     <div className="news-time">发布时间： 2022-09-09</div>
            //                                 </div>
            //                             </div>

            //                         ))
            //                     }

            //                 </div>
            //             </TabPane>
            //             <TabPane tab="公司动态" key="2">
            //                 <div className="common-block-case">
            //                     {
            //                         partnerList && partnerList.map((item, index) => (
            //                             <div className="news-detail-block" key={index}>
            //                                 <img className="case-detail-img" src={item.img} alt="" />
            //                                 <div className="news-detail-tips">
            //                                     <a className="news-title" href="https://mp.weixin.qq.com/s/RrO6fYoPupu1R81YVDWy6Q">悦喵Ai首次亮相第十四届中国商业信息化行业大会 &gt;</a>
            //                                     <div className="news-time">发布时间： 2022-09-09</div>
            //                                 </div>
            //                             </div>

            //                         ))
            //                     }

            //                 </div>
            //             </TabPane>
                        
            //         </Tabs>
            //     </div>

            // </div >
        )
    }
}


export default NewsCenter